<!-- src/components/CreatePosterPopup.vue -->
<template>
    <v-dialog v-model="dialog" max-width="800" persistent>
      <v-card>
        <v-card-title class="headline">新建海报</v-card-title>
        <v-divider></v-divider>

        <v-card-text class="pt-4">

          <v-form ref="form" v-model="valid">

            <v-select
              v-model="formData.recruitmentAreaId"
              :items="recruitmentAreas"
              item-text="name"
              item-value="id"
              label="招聘地区（必填）"
              :rules="[v => !!v || '必填项']"
              outlined
              dense
              required
            ></v-select>


            <!-- 封面图片 -->
            <image-uploader
              :imageUrl="formData.coverImageUrl"
              @file-changed="handleFileChange"
              class="mb-4"
            />
  
            <!-- 基础信息 -->
            <v-card outlined class="mb-4">
              <v-card-title class="subtitle-1">基础信息</v-card-title>
              <v-card-text>
                <v-text-field
                  v-model="formData.posterDetail.title"
                  label="海报标题*"
                  :rules="[v => !!v || '必填项']"
                  outlined
                ></v-text-field>
  
                <v-text-field
                  v-model="formData.posterDetail.companyName"
                  label="公司名称*"
                  :rules="[v => !!v || '必填项']"
                  outlined
                ></v-text-field>
  
                <v-textarea
                  v-model="formData.posterDetail.companyIntroduce"
                  label="公司介绍*"
                  :rules="[v => !!v || '必填项']"
                  outlined
                  rows="3"
                ></v-textarea>
              </v-card-text>
            </v-card>
  
            <!-- 职位信息 -->
          <v-card outlined class="mb-4">
            <v-card-title class="subtitle-1 d-flex justify-space-between align-center">
              职位信息
              <v-btn small color="primary" @click="addPosition">
                <v-icon left>mdi-plus</v-icon>新增职位
              </v-btn>
            </v-card-title>
            <v-card-text>
              <div v-for="(position, index) in formData.posterDetail.positionInfos" 
                   :key="index" 
                   class="mb-6 pa-4 lighten-5 rounded-lg">
                <div class="d-flex justify-space-between align-center mb-2">
                  <span class="body-1">职位 {{ index + 1 }}</span>
                  <v-btn icon small @click="removePosition(index)">
                    <v-icon color="error">mdi-delete</v-icon>
                  </v-btn>
                </div>
                
                <v-text-field
                  v-model="position.positionCh"
                  label="中文职位名称*"
                  :rules="[v => !!v || '必填项']"
                  outlined
                ></v-text-field>

                <v-text-field
                  v-model="position.positionEn"
                  label="英文职位名称*"
                  :rules="[v => !!v || '必填项']"
                  outlined
                ></v-text-field>

                <div class="pl-4">
                  <div class="d-flex align-center mb-2">
                    <span class="body-2">职位要求</span>
                    <v-btn icon small @click="addRequirement(position)">
                      <v-icon small>mdi-plus</v-icon>
                    </v-btn>
                  </div>
                  <v-text-field
                    v-for="(req, reqIndex) in position.positionRequired"
                    :key="reqIndex"
                    v-model="position.positionRequired[reqIndex]"
                    :label="`要求 ${reqIndex + 1}`"
                    outlined
                    class="mb-2"
                  >
                    <template v-slot:append>
                      <v-icon
                        small
                        @click="removeRequirement(position, reqIndex)"
                        color="error"
                      >
                        mdi-close
                      </v-icon>
                    </template>
                  </v-text-field>
                </div>
              </div>
            </v-card-text>
          </v-card>

          <!-- 实习信息 -->
          <v-card outlined class="mb-4">
            <v-card-title class="subtitle-1">实习信息</v-card-title>
            <v-card-text>
              <v-row>
                <v-col cols="6">
                  <v-text-field
                    v-model="formData.posterDetail.profession"
                    label="专业要求"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="formData.posterDetail.intershipType"
                    label="实习类型"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="formData.posterDetail.intershipPlace"
                    label="实习地点"
                    outlined
                  ></v-text-field>
                </v-col>
                <v-col cols="6">
                  <v-text-field
                    v-model="formData.posterDetail.intershipPeriod"
                    label="实习周期"
                    outlined
                  ></v-text-field>
                </v-col>
              </v-row>

              <div class="pl-4">
                <div class="d-flex align-center mb-2">
                  <span class="body-2">实习收获</span>
                  <v-btn icon small @click="addIntershipGain">
                    <v-icon small>mdi-plus</v-icon>
                  </v-btn>
                </div>
                <v-text-field
                  v-for="(gain, index) in formData.posterDetail.intershipGains"
                  :key="index"
                  v-model="formData.posterDetail.intershipGains[index]"
                  :label="`收获 ${index + 1}`"
                  outlined
                  class="mb-2"
                >
                  <template v-slot:append>
                    <v-icon
                      small
                      @click="removeIntershipGain(index)"
                      color="error"
                    >
                      mdi-close
                    </v-icon>
                  </template>
                </v-text-field>
              </div>
            </v-card-text>
          </v-card>
          <!-- 培训信息 -->
          <section-info
            title="培训信息"
            :items="formData.posterDetail.preTraining"
            @add="addTraining"
            @remove="removeTraining"
            @update="val => formData.posterDetail.preTraining = val"
            field1-label="培训标题"
            field2-label="培训描述"
          />

          <!-- 项目启动 -->
          <section-info
            title="项目启动"
            :items="formData.posterDetail.projectStart"
            @add="addProjectStart"
            @remove="removeProjectStart"
            @update="val => formData.posterDetail.projectStart = val"
            field1-label="阶段标题"
            field2-label="阶段描述"
          />

          <!-- 项目收获 -->
          <section-info
            title="项目收获"
            :items="formData.posterDetail.projectGains"
            @add="addProjectGain"
            @remove="removeProjectGain"
            @update="val => formData.posterDetail.projectGains = val"
            field1-label="收获标题"
            field2-label="收获描述"
          />
  
          </v-form>
        </v-card-text>
  
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="grey" text @click="close">取消</v-btn>
          <v-btn 
            color="primary" 
            text 
            @click="submit"
            :loading="saving"
            :disabled="!valid"
          >
            创建
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
  
  <script>
  import { posterApi } from '@/api/poster'
  import { dropdownOptionsApi } from '@/api/dropdownOptions'
  import SectionInfo from '@/components/SectionInfo'
  import ImageUploader from '@/components/ImageUploader'
  
  export default {
    name: 'CreatePosterPopup',
    components: { SectionInfo, ImageUploader },
    data() {
      return {
        dialog: false,
        valid: false,
        saving: false,
        coverImageFile: null,
        recruitmentAreas: [],
        formData: {
          recruitmentAreaId: 0,
          coverImageUrl: '',
          posterDetail: {
            title: '',
            companyName: '',
            companyIntroduce: '',
            positionInfos: [{
              positionEn: '',
              positionCh: '',
              positionRequired: ['']
            }],
            profession: '',
            intershipType: '',
            intershipPlace: '',
            intershipPeriod: '',
            intershipGains: [''],
            preTraining: [],
            projectStart: [],
            projectGains: []
          }
        }
      }
    },

    created() {
      this.loadDropdownOptions()
    },
  
    methods: {
      open() {
        this.dialog = true
      },
  
      close() {
        this.dialog = false
        this.$refs.form.reset()
        this.coverImageFile = null
        // 重置表单数据
        this.formData = {
          coverImageUrl: '',
          posterDetail: {
            ...this.formData.posterDetail,
            title: '',
            companyName: '',
            companyIntroduce: '',
            positionInfos: [{
              positionEn: '',
              positionCh: '',
              positionRequired: ['']
            }]
          }
        }
      },
  
      handleFileChange(file) {
        console.log('handleFileChange 触发')
        if (file) {
          this.coverImageFile = file
          this.formData.coverImageUrl = URL.createObjectURL(file)
          console.log('this.formData.coverImageUrl = ', this.formData.coverImageUrl)
        } else {
          this.coverImageFile = null
          this.formData.coverImageUrl = null
        }
      },
  
      async submit() {
        if (!this.$refs.form.validate()) return
  
        this.saving = true
        try {
          const formData = new FormData()
          if (this.coverImageFile) {
            formData.append('coverImageFile', this.coverImageFile)
          }
          formData.append('recruitmentAreaId', this.formData.recruitmentAreaId)
          formData.append('posterDetailJsonString', 
            JSON.stringify(this.formData.posterDetail))
  
          const response = await posterApi.createPoster(formData)
          
          if (response.code === '2000') {
            this.$emit('poster-created')
            this.close()
            this.$toast.success('创建成功')
          }
        } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
          this.$toast.error('创建失败 : ' + errorMessage);
        } finally {
          this.saving = false
        }
      },
  
    // 职位相关操作
    addPosition() {
      this.formData.posterDetail.positionInfos.push({
        positionEn: '',
        positionCh: '',
        positionRequired: ['']
      })
    },
    removePosition(index) {
      this.formData.posterDetail.positionInfos.splice(index, 1)
    },

    // 职位要求操作
    addRequirement(position) {
      position.positionRequired.push('')
    },
    removeRequirement(position, index) {
      position.positionRequired.splice(index, 1)
    },

    // 实习收获操作
    addIntershipGain() {
      this.formData.posterDetail.intershipGains.push('')
    },
    removeIntershipGain(index) {
      this.formData.posterDetail.intershipGains.splice(index, 1)
    },

    // 培训信息操作
    addTraining() {
      this.formData.posterDetail.preTraining.push({
        subTitle: '',
        description: ''
      })
    },
    removeTraining(index) {
      this.formData.posterDetail.preTraining.splice(index, 1)
    },

    // 项目启动操作
    addProjectStart() {
      this.formData.posterDetail.projectStart.push({
        subTitle: '',
        description: ''
      })
    },
    removeProjectStart(index) {
      this.formData.posterDetail.projectStart.splice(index, 1)
    },

    // 项目收获操作
    addProjectGain() {
      this.formData.posterDetail.projectGains.push({
        subTitle: '',
        description: ''
      })
    },
    removeProjectGain(index) {
      this.formData.posterDetail.projectGains.splice(index, 1)
    },

    async loadDropdownOptions() {
      this.loadingOptions = true
      try {
          const requests = [
              dropdownOptionsApi.getRecruitmentAreas()
          ]

      const [recruitmentAreaRes] = await Promise.all(requests)

      this.recruitmentAreas = this.formatOptions(recruitmentAreaRes.data)
      } catch (error) {
          const errorMessage = error.response?.data?.message || error.message || '未知错误';
          this.$toast.error('无法加载下拉选项数据 : ' + errorMessage);
      } finally {
          this.loadingOptions = false
      }
    },

    formatOptions(data) {
            return data?.map(item => ({
                name: item.name,
                id: Number(item.id) // 确保转换为数字类型
            })) || []
        },
    }
  }
  </script>
  
  <style scoped>
  .position-card {
    border: 1px solid #eee;
    border-radius: 8px;
    padding: 16px;
    margin-bottom: 16px;
  }
  </style>